/* eslint-disable no-unused-vars */
var utils_vars = {
	head: document.head,
	body: document.body,
	breakpoint: {
		xs: 0,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
		xxl: 1400,
	},
	screen: {
		width: window.visualViewport.width || window.innerWidth,
		height: window.visualViewport.height || window.innerHeight,
	},
	docWidth: document.documentElement.clientWidth,
	observerReady: "IntersectionObserver" in window,
	srcsetReady: "sizes" in document.createElement("img"),
	scrollBarWidth: 0,
	cssOverflow: false,

	// funzione di caricamento ajax
	ajaxLoad(url, method, contentType, type, params, callback) {
		var oReq = new XMLHttpRequest();
		oReq.onload = function (e) {
			var response = e.target.response;
			if (callback) {
				callback(response);
			}
		};
		oReq.open(method, url, true);
		if (type) {
			oReq.responseType = type;
		}
		if (contentType) {
			oReq.setRequestHeader("Content-type", contentType);
		}
		if (params) {
			oReq.send(params);
		} else {
			oReq.send();
		}
	},

	// DOM ready
	domReady: (callback) => {
		document.readyState === "interactive" || document.readyState === "complete"
			? callback()
			: document.addEventListener("DOMContentLoaded", callback);
	},

	// loop helper
	forEach(array, callback, scope) {
		for (var i = 0; i < array.length; i++) {
			callback.call(scope, i, array[i]);
		}
	},

	loadScript(link, async, callback, external = false) {
		var script = document.createElement("script");
		if (external) {
			script.src = link;
		} else {
			script.src = "/app/themes/merotto/js/" + link;
		}
		if (async) {
			script.setAttribute("async", "");
		}
		if (callback) {
			script.addEventListener("load", callback);
		}
		document.body.appendChild(script);
	},

	loadStyle: function (link, external = false) {
		var css = document.createElement("link");

		if (external) {
			css.href = link;
		} else {
			css.href = "/app/themes/merotto/css/" + link;
		}

		css.rel = "stylesheet";
		document.head.appendChild(css);
	},

	isMobile: () => utils_vars.screen.width < utils_vars.breakpoint.md,
	isTablet: () => utils_vars.screen.width < utils_vars.breakpoint.lg, //TODO da verificare
};

export default utils_vars;
